/* tslint:disable */
/* eslint-disable */
/* @relayHash 7501d6397ea5d38a684af2d30aa676c5 */

import { ConcreteRequest } from "relay-runtime";
export type CompleteAccountEmailInput = {
    email: string;
    clientMutationId?: string | null;
};
export type completeAccountEmailMutationVariables = {
    input: CompleteAccountEmailInput;
};
export type completeAccountEmailMutationResponse = {
    readonly completeAccountEmail: {
        readonly message: string | null;
    } | null;
};
export type completeAccountEmailMutation = {
    readonly response: completeAccountEmailMutationResponse;
    readonly variables: completeAccountEmailMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CompleteAccountEmailPayload",
    "kind": "LinkedField",
    "name": "completeAccountEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "completeAccountEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "completeAccountEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/329.0.0-2021-08-23T09:21:35.606Z/completeAccountEmailMutation",
    "metadata": {},
    "name": "completeAccountEmailMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '883b4525d2b17ac04896e764ae2e1f1b';
export default node;
